// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Photos__row":"st_a bhm_a bhm_r bhm_j","Photos__img":"st_b bhm_b"};